import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {},
    settings: {},
    status: 'idle', // idle loading success fail  
    statusUpdate: 'idle', // idle loading success fail  
    error: null
}
/**
 * 
 * ~~ = ignore
 * ~_~ = delete/set to default value
 */
const PLATFORM = '../../WsWebServicePlatform/'
const WELLSUITE = '../../WsWebServiceWellSuite/';

//Participant/Login/UpdatePwr

// {
//     "ParamData": {
//     "PwrGuid": "6F5619F3-A5EA-460C-9919-841D84BF1900", 
//     "Username": "jsample1",
//     "Password": "mypass"
//     }
// }

//searchParams.get("pwrg")

//Participant/Login/Password/Reset
// “ParamData”: {
//     “AuthToken”: "15A72D10-AB64-4A6E-AA93-53A63223D79F",
//     “ParticipantGuid”: "471181D6-5840-4AB8-A6B9-EB7644258A9C",
//     “Password”: "NEWpasswd",
//     }
//    }

// wellsuite GetViewInstancePwr/{PwrGuid}/	
export const fetchPWRequest = createAsyncThunk('pwrequest/get', async (incomingVariable, thunkAPI) => {
    
    try {
        

        const response = await axios.post(PLATFORM + "Participant/Pwr/" + incomingVariable.GroupGuid + "/" + incomingVariable.Username + "/-1/" + incomingVariable.SystemComponentKeyName +"/")
        const data = await response.data

        return data
    } catch (err) {
    
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const fetchSelfRegAndPWRequest = createAsyncThunk('selfregrequest/get', async (incomingVariable, thunkAPI) =>{

    try {
        const JsonPayload = {FirstName: incomingVariable.FirstName, LastName: incomingVariable.LastName}
        const bodies = {
            ParamData: {
                GroupGuid: incomingVariable.GroupGuid
                , Username: incomingVariable.Username
                , Email: incomingVariable.Email
                ,JsonPayload: JSON.stringify(JsonPayload)
               
            }
        }
        const response = await axios.post(PLATFORM + "Group/ParticipantAndLogin/SelfRegister", bodies)
        //console.log(response.data)
        const Lang = await response?.data?.Info 
                    && response.data.Info.length > 0
                    && response.data.Success
                    && response.data.Info[0].AuthToken
                    && axios.post(PLATFORM
                    + PLATFORM + "Participant/Pwr" 
                        , {ParamData: { GroupGuid: incomingVariable.GroupGuid 
                            ,Username: incomingVariable.Username 
                            , LanguageID: incomingVariable.LanguageID 
                            , SystemComponentKeyName:incomingVariable.SystemComponentKeyName
                        }
                    }
                    )
        return {...Lang.data, ...response.data}
    } catch (err){
        return thunkAPI.rejectWithValue({ error: err.message });
    }
}

)

export const fetchSelfRegistration = createAsyncThunk('selfregistration/get', async (incomingVariable, thunkAPI) => {
    
    try {
        
        const bodies = {
            ParamData: {
                GroupGuid: incomingVariable.GroupGuid
                , Username: incomingVariable.Username
                , Email: incomingVariable.Email
                , FirstName: incomingVariable.FirstName
                , LastName: incomingVariable.LastName
            }
        }
        const response = await axios.get(PLATFORM + "Group/ParticipantAndLogin/SelfRegister", bodies)
        const data = await response.data

        return data
    } catch (err) {
    
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})
const pwrequestSlice = createSlice({
    name: 'pwrequest',
    initialState,
    reducers: {                
        pwrequestClearVI(state, action) {
            state.entities = {}
            state.status = "idle"
        },
        pwrequestClearUpdate(state, action) {            
            state.entities = {}
            state.settings = {}
            state.status = 'idle' 
            state.statusUpdate = 'idle'
            state.error = null
        }            
    },
    
    extraReducers(builder) {
        builder
            // pw no auth with guid
            .addCase(fetchPWRequest.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchPWRequest.fulfilled, (state, action) => {
                const Success = action.payload.Success
                if (Success===true){
                    state.entities = action.payload.Info[0].ViewInstanceData[0]
                    state.settings = action.payload.Info[0].ViewInstanceData[1]
                    state.status = 'success'
                } else {
                    state.status = "failed"
                    state.error = action.payload.Status[0]
                }
            })
            .addCase(fetchPWRequest.rejected, (state, action) => {
                state.error = action.error.message
                
            })   
            // self registration
            .addCase(fetchSelfRegistration.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchSelfRegistration.fulfilled, (state, action) => {
                console.log(action.payload)
                const Success = action.payload.Success
                if (Success===true){
                    state.entities = action.payload.Info[0].ViewInstanceData[0]
                    state.settings = action.payload.Info[0].ViewInstanceData[1]
                    state.status = 'success'
                } else {
                    state.status = "failed"
                    state.error = action.payload.Status[0]
                }
            })
            .addCase(fetchSelfRegistration.rejected, (state, action) => {
                state.error = action.error.message
                
            })   
            // self registration
            .addCase(fetchSelfRegAndPWRequest.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchSelfRegAndPWRequest.fulfilled, (state, action) => {
                const Success = action.payload.Success
                console.log(action.payload)
                if (Success===true){
                    state.entities = action.payload.Info[0]
                    state.status = 'success'
                } else {
                    state.status = "failed"
                    state.error = action.payload.Status[0]
                }
            })
            .addCase(fetchSelfRegAndPWRequest.rejected, (state, action) => {
                state.error = action.error.message
                
            })   

            
           
    }
})


export const { pwrequestClearVI,  pwrequestClearUpdate} = pwrequestSlice.actions
export default pwrequestSlice.reducer


export const selectPwResetEntities = (state) => state.pwrequest.entities
export const selectPwResetStatus = (state) => state.pwrequest.status
export const selectPwResetError = (state) => state.pwrequest.error